/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleProductivityList
 */
export interface VehicleProductivityList {
    /**
     * 
     * @type {boolean}
     * @memberof VehicleProductivityList
     */
    vehicleSerialNumber: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleProductivityList
     */
    vehicleManufacturer: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleProductivityList
     */
    vehicleModel: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleProductivityList
     */
    vehicleEngineType: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleProductivityList
     */
    vehicleManufactureYear: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleProductivityList
     */
    vehicleLastSynchronizedAt: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleProductivityList
     */
    vehicleTypeLabel: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleProductivityList
     */
    departmentLabel: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleProductivityList
     */
    vehicleGroupLabel: boolean;
}

/**
 * Check if a given object implements the VehicleProductivityList interface.
 */
export function instanceOfVehicleProductivityList(value: object): value is VehicleProductivityList {
    if (!('vehicleSerialNumber' in value) || value['vehicleSerialNumber'] === undefined) return false;
    if (!('vehicleManufacturer' in value) || value['vehicleManufacturer'] === undefined) return false;
    if (!('vehicleModel' in value) || value['vehicleModel'] === undefined) return false;
    if (!('vehicleEngineType' in value) || value['vehicleEngineType'] === undefined) return false;
    if (!('vehicleManufactureYear' in value) || value['vehicleManufactureYear'] === undefined) return false;
    if (!('vehicleLastSynchronizedAt' in value) || value['vehicleLastSynchronizedAt'] === undefined) return false;
    if (!('vehicleTypeLabel' in value) || value['vehicleTypeLabel'] === undefined) return false;
    if (!('departmentLabel' in value) || value['departmentLabel'] === undefined) return false;
    if (!('vehicleGroupLabel' in value) || value['vehicleGroupLabel'] === undefined) return false;
    return true;
}

export function VehicleProductivityListFromJSON(json: any): VehicleProductivityList {
    return VehicleProductivityListFromJSONTyped(json, false);
}

export function VehicleProductivityListFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleProductivityList {
    if (json == null) {
        return json;
    }
    return {
        
        'vehicleSerialNumber': json['vehicleSerialNumber'],
        'vehicleManufacturer': json['vehicleManufacturer'],
        'vehicleModel': json['vehicleModel'],
        'vehicleEngineType': json['vehicleEngineType'],
        'vehicleManufactureYear': json['vehicleManufactureYear'],
        'vehicleLastSynchronizedAt': json['vehicleLastSynchronizedAt'],
        'vehicleTypeLabel': json['vehicleTypeLabel'],
        'departmentLabel': json['departmentLabel'],
        'vehicleGroupLabel': json['vehicleGroupLabel'],
    };
}

export function VehicleProductivityListToJSON(json: any): VehicleProductivityList {
    return VehicleProductivityListToJSONTyped(json, false);
}

export function VehicleProductivityListToJSONTyped(value?: VehicleProductivityList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vehicleSerialNumber': value['vehicleSerialNumber'],
        'vehicleManufacturer': value['vehicleManufacturer'],
        'vehicleModel': value['vehicleModel'],
        'vehicleEngineType': value['vehicleEngineType'],
        'vehicleManufactureYear': value['vehicleManufactureYear'],
        'vehicleLastSynchronizedAt': value['vehicleLastSynchronizedAt'],
        'vehicleTypeLabel': value['vehicleTypeLabel'],
        'departmentLabel': value['departmentLabel'],
        'vehicleGroupLabel': value['vehicleGroupLabel'],
    };
}

